<div class="rich-text max-w-none p-8 mt-12 text-2xl bg-red/5 text-center rounded-xl">
	<slot />
</div>